export default {
    name: 'NumberRangeAppend',
    functional: true,
    props: {
        render: Function
    },
    render: (h,ctx) => {
        return ctx.props.render(h);
    }
};



// WEBPACK FOOTER //
// ./src/components/numberbox/append.js